var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYueshu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631345",
    d: "M5.375 9.83595H2.7793V1.875H10.7402V9.83595H8.125",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631346",
    d: "M12.1406 6.16405L14.7207 6.16405L14.7207 14.125L6.75975 14.125L6.75975 6.16405L9.32813 6.16405",
    stroke: "black",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYueshu);
export default __webpack_public_path__ + "static/media/yueshu.9d5c33a9fa0c42cc8a40f297748c95d4.svg";
export { ForwardRef as ReactComponent };